// Cores aproximadas de identidade visual dos principais partidos brasileiros.
// Partidos fora da lista caem no fallback determinístico (hash da sigla).
const CORES_CONHECIDAS = {
  PT: '#C1272D',
  PL: '#0047AB',
  MDB: '#E30613',
  PSDB: '#0033A0',
  PSD: '#005BAA',
  UNIÃO: '#002D72', // União Brasil
  REPUBLICANOS: '#1B3F8B',
  PDT: '#CC092F',
  PSOL: '#E4032E',
  'PC do B': '#D2232A',
  NOVO: '#FF6600',
  REDE: '#00A651',
  PV: '#009444',
  PP: '#4A2E83',
  PSB: '#facc15',
  PODE: '#166534',
  CIDADANIA: '#f59e0b',
  AVANTE: '#0891b2',
  SOLIDARIEDADE: '#ea580c',
  PATRIOTA: '#065f46',
  PROS: '#0369a1',
  DC: '#0f172a',
  PSC: '#7e22ce',
  PMN: '#6b7280',
  AGIR: '#334155',
  MOBILIZA: '#0284c7',
};

const PALETA_FALLBACK = [
  '#6366f1',
  '#059669',
  '#d97706',
  '#db2777',
  '#0891b2',
  '#7c3aed',
  '#65a30d',
  '#e11d48',
];

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function corDoPartido(sigla) {
  if (!sigla) return '#8b98a5';
  if (CORES_CONHECIDAS[sigla]) return CORES_CONHECIDAS[sigla];
  return PALETA_FALLBACK[hash(sigla) % PALETA_FALLBACK.length];
}
